import { Menu } from '@mui/material';

import { MenuOption } from 'src/routes/appSetup/setup/components/app-list/app-list-item/MenuOption';

interface PageTitleMenuProps {
  anchorEl: HTMLElement | null;
  onClose: () => void;
  onRename: () => void;
  onManage: () => void;
}

export const PageTitleMenu = ({
  anchorEl,
  onClose,
  onRename,
  onManage,
}: PageTitleMenuProps) => (
  <Menu
    open={Boolean(anchorEl)}
    anchorEl={anchorEl}
    onClose={onClose}
    anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
    transformOrigin={{ vertical: 'top', horizontal: 'left' }}
    classes={{
      paper:
        'bg-white border border-solid border-secondary-hover shadow-popover-050',
    }}
  >
    <MenuOption icon="Edit" text="Rename app" onClick={onRename} />
    <MenuOption icon="Settings" text="Manage app" onClick={onManage} />
  </Menu>
);
